import React, { useEffect, useRef } from "react";
import { ArtistItem } from "../topArtistList";

const HorizontalPager = ({ data, showArtist }) => {
  const containerRef = useRef(null);
  useEffect(() => {
    if (containerRef.current) {
      // Scroll to the second item (index 1)
      const secondItem = containerRef.current.children[1];
      secondItem.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center",
      });
    }
  }, []);

  return (
    <div className="scroll-snap-container" ref={containerRef}>
      <div key="space1" className="spacer"></div>
      {data &&
        data.top_artists &&
        data.top_artists.map((item, index) => (
          <button
            key={"arist-" + index}
            className="artist-item"
            onClick={() => showArtist(item)}
          >
            <ArtistItem key={index} data={item} />
          </button>
        ))}
      <div key="space2" className="spacer"></div>
    </div>
  );
};

export default HorizontalPager;
